import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  ConvertDateToDashesAndTimeFormat,
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  formateDateWithTime,
  getDifferenceInDays,
  GetIndexExactlyMatchingColumn,
  getStartOfNext5Years,
  getStartOfPreviousMonth,
  isValidDate,
  SortTheList,
  VanAvailabilityTypes,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import { showErrorMessage } from "../Shared/Toast";

function MoverUnavailability() {
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [MNVMoverID, setMNVMoverID] = useState(globalState.MNVMoverID);
  const [slotModalOpen, setSlotModalOpen] = useState(false);
  let [addEditObject, setAddEditObject] = useState<any>({
    MNVMoverUnavailabilityID: 0,
    MNVMoverID: globalState.MNVMoverID,
    RuleTypeID: 1,
    RuleFirstEntryID: 1,
    IsApproved: false,
    Name: "Unapproved",
    Reason: "",
    StartDate: new Date(),
    EndDate: new Date(),
    UseFullDay: false,
  });
  const [filterObject, setFilterbject] = useState({
    startdate: getStartOfPreviousMonth(),
    enddate: getStartOfNext5Years(),
  });
  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);
  const [OtherRecordsOfThisRule, setOtherRecordsOfThisRule] = useState<any>([]);
  const [approvalTypeModal, setapprovalTypeModal] = useState(false);
  const [RecordInEditModeCurrently, setRecordInEditModeCurrently] = useState(0);
  const RecordInEditModeCurrentlyRef: any = useRef(null);
  RecordInEditModeCurrentlyRef.current = RecordInEditModeCurrently;
  useEffect(() => {
    getScreenListData();
  }, []);

  useEffect(() => {
    getScreenData();
  }, [MNVMoverID]);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
        "api/MNVMoverUnavailability/MNVMoverUnavailabilityGetCompleteDataSetForForeignKeys",
      )
      .then((response) => {
        let l_oResponse = response.data;
        setScreenListData(l_oResponse);

        if (
          l_oResponse[1] &&
          l_oResponse[1].length > 0 &&
          l_oResponse[1][0]["MNVMoverID"] > -1
        )
          setMNVMoverID(l_oResponse[1][0]["MNVMoverID"]);

        // setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVMoverID = AppContext.MNVMoverID;
    object.StartDate = filterObject.startdate;
    object.EndDate = filterObject.enddate;
    axiosAuth
      .post(
        AppContext.APIURL +
        "api/MNVMoverUnavailability/MNVMoverUnavailabilityGetCompleteGridDataCustom",
        object,
      )
      .then((response) => {
        let l_oResponse = response.data[0];
        if (MNVMoverID > 0) {
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "MNVMoverID",
            MNVMoverID,
          );
        }

        l_oResponse = FilterJsonExactlyMatching(
          l_oResponse,
          "IsDeleted",
          false,
        );
        if (selectedMoverID && selectedMoverID > 0) {
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "MNVVanID",
            selectedMoverID,
          );
        }
        const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
        const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
        setThisGridListDataWithoutFilters(deepCopy1);
        setThisGridListData(deepCopy2);
        thisGridListDataRef.current = deepCopy2;
        setScreenData(l_oResponse);

        setSlotModalOpen(false);
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation(update: boolean, p_gridview: boolean) {
    var IsOkay = true;
    if (!addEditObject.MNVMoverID || addEditObject.MNVMoverID == 0) {
      showErrorMessage("Please select mover");
      IsOkay = false;
    } else if (!addEditObject.Reason || addEditObject.Reason == "") {
      showErrorMessage("Please enter reason");
      IsOkay = false;
    } else if (!isValidDate(addEditObject.StartDate)) {
      showErrorMessage("Please select start date");
      IsOkay = false;
    } else if (!isValidDate(addEditObject.EndDate)) {
      showErrorMessage("Please select end date");
      IsOkay = false;
    } else if (
      isValidDate(addEditObject.StartDate) &&
      isValidDate(addEditObject.EndDate) &&
      ((new Date(addEditObject.StartDate).setHours(0, 0, 0, 0) >
        new Date(addEditObject.EndDate).setHours(0, 0, 0, 0) &&
        addEditObject.UseFullDay) ||
        (new Date(addEditObject.StartDate) > new Date(addEditObject.EndDate) &&
          !addEditObject.UseFullDay))
    ) {
      showErrorMessage("End date must be greater than start date.");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveScreenData(update, p_gridview);
    }
  }

  function saveScreenData(update: boolean, gridview: boolean) {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVMoverUnavailabilityID = addEditObject.MNVMoverUnavailabilityID;
    object.MNVMoverID = addEditObject.MNVMoverID;
    object.RuleTypeID = addEditObject.RuleTypeID;
    object.RuleFirstEntryID = addEditObject.RuleFirstEntryID;
    object.IsApproved = addEditObject.IsApproved;
    object.Name = addEditObject.Name;
    object.Reason = addEditObject.Reason;
    object.StartDate = addEditObject.StartDate;
    object.EndDate = addEditObject.EndDate;

    if (addEditObject.UseFullDay) {
      var l_oDate = new Date(addEditObject.StartDate);
      object.StartDate = ConvertDateToDashesAndTimeFormat(
        new Date(
          new Date(
            l_oDate.getFullYear(),
            l_oDate.getMonth(),
            l_oDate.getDate(),
            0,
            0,
            0,
            0,
          ),
        ),
      );
      l_oDate = new Date(addEditObject.EndDate);
      object.EndDate = ConvertDateToDashesAndTimeFormat(
        new Date(
          new Date(
            l_oDate.getFullYear(),
            l_oDate.getMonth(),
            l_oDate.getDate(),
            23,
            59,
            59,
            0,
          ),
        ),
      );
    }

    let thisULR =
      AppContext.APIURL +
      "api/MNVMoverUnavailability/MNVMoverUnavailabilitySaveCustom";
    if (update == true) {
      thisULR =
        AppContext.APIURL +
        "api/MNVMoverUnavailability/MNVMoverUnavailabilitySave";
    }

    axiosAuth
      .post(thisULR, object)
      .then((response) => {
        let l_response = response.data.Data;
        if (l_response && l_response[0] && l_response[0].Status == 0) {
          showErrorMessage(l_response[0].Message);
        } else {
          if (gridview == true) setIsAddNew(0);
          getScreenData();
        }

        if (isAddNew == 2 && gridview == false) {
          MNVMoverUnavailabilityGetCompleteGridDataForThisRule(
            addEditObject.RuleFirstEntryID,
            RecordInEditModeCurrently,
          );
        } else {
          setIsAnimation(false);
        }
        setSlotModalOpen(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVVanID = pid;
    axiosAuth
      .post(AppContext.APIURL + "api/MNVVan/MNVVanDeleteRecord", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        // deleteThisRecord(obj.SelectedID);
        MNVMoverUnavailabilityDeleteRecord(
          obj.SelectedID,
          obj.OtherID > 1 ? "" : "",
        );
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVVanTypeName")) {
        (
          document.getElementById(
            "imgSort" + "MNVVanTypeName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVBaseName")) {
        (
          document.getElementById("imgSort" + "MNVBaseName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVMoverName")) {
        (
          document.getElementById(
            "imgSort" + "MNVMoverName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  const CheckApprovalType = (
    MNVMoverUnavailabilityID: number,
    p_oID: any,
    p_intIndex: number,
  ) => {
    let l_intIndex = GetIndexExactlyMatchingColumn(
      thisGridListData,
      "MNVMoverUnavailabilityID",
      MNVMoverUnavailabilityID,
    );

    let currentUnavailability = null;

    if (l_intIndex > -1) {
      p_intIndex = l_intIndex;
      currentUnavailability = { ...thisGridListData[p_intIndex] };

      if (
        currentUnavailability.MNVMoverUnavailabilityID !==
        currentUnavailability.NextMNVMoverUnavailabilityID
      ) {
        currentUnavailability.MNVMoverUnavailabilityID =
          currentUnavailability.NextMNVMoverUnavailabilityID;
        currentUnavailability.StartDate = currentUnavailability.NextStartDate;
        currentUnavailability.EndDate = currentUnavailability.NextEndDate;
      }
    } else if (isAddNew == 2) {
      l_intIndex = GetIndexExactlyMatchingColumn(
        OtherRecordsOfThisRule,
        "MNVMoverUnavailabilityID",
        MNVMoverUnavailabilityID,
      );

      if (l_intIndex > -1) {
        p_intIndex = l_intIndex;
        currentUnavailability = {
          ...OtherRecordsOfThisRule[p_intIndex],
        };
      }
    }

    if (l_intIndex > -1 && currentUnavailability) {
      if (p_oID === "" || currentUnavailability.Name === "Approved") {
        currentUnavailability.Name =
          currentUnavailability.Name === "Unapproved"
            ? "Approved"
            : "Unapproved";
        addEditObject = currentUnavailability;
        setAddEditObject(currentUnavailability);

        checkValidation(true, false);
      } else {
        currentUnavailability.RuleTypeID = 1;
        addEditObject = currentUnavailability;
        setAddEditObject(currentUnavailability);
        setapprovalTypeModal(true);
      }
    }
  };

  const MNVMoverUnavailabilityApproveAll = () => {
    if (addEditObject.RuleTypeID > 1) {
      const data: any = {
        MNVMoverUnavailabilityID: addEditObject.MNVMoverUnavailabilityID,
      };

      setIsAnimation(true);

      axiosAuth
        .post(
          AppContext.APIURL +
          "api/MNVMoverUnavailability/MNVMoverUnavailabilityApproveAll",
          data,
        )
        .then(() => {
          setIsAnimation(false);
          setapprovalTypeModal(false);

          getScreenData();

          if (isAddNew == 2) {
            MNVMoverUnavailabilityGetCompleteGridDataForThisRule(
              addEditObject.RuleFirstEntryID,
              RecordInEditModeCurrently,
            );
          }
        })
        .catch((error) => {
          setIsAnimation(false);
          console.error(error);
        });
    } else {
      const updatedUnavailability = {
        ...addEditObject,
        Name: "Approved",
      };
      addEditObject = updatedUnavailability;
      setAddEditObject(updatedUnavailability);

      checkValidation(true, false);

      setapprovalTypeModal(false);
    }
  };

  const MNVMoverUnavailabilityDeleteRecord = (id: number, p_oID: any) => {
    let unavailability = addEditObject;

    if (id > 0) {
      unavailability = {
        ...addEditObject,
        MNVMoverUnavailabilityID: id,
        RuleTypeID: 1,
      };
      setAddEditObject(unavailability);
    }

    if (p_oID !== "") {
      setSlotModalOpen(true);
      setIsAddNew(2);
      return;
    }

    if (
      unavailability.RuleTypeID == undefined ||
      unavailability.RuleTypeID <= 1
    )
      unavailability.RuleTypeID = 1;

    const data: any = {
      MNVMoverUnavailabilityID: unavailability.MNVMoverUnavailabilityID,
      RuleTypeID: unavailability.RuleTypeID,
    };

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL +
        "api/MNVMoverUnavailability/MNVMoverUnavailabilityDeleteRecord",
        data,
      )
      .then(() => {
        setIsAnimation(false);
        setapprovalTypeModal(false);

        getScreenData();

        if (isAddNew == 2 && unavailability.RuleTypeID > 1) {
          setIsAddNew(0);
        } else if (isAddNew == 2) {
          let nextRecordIndex = RecordInEditModeCurrently;

          if (
            RecordInEditModeCurrently ===
            unavailability.MNVMoverUnavailabilityID
          ) {
            nextRecordIndex = RecordInEditModeCurrently + 1;
            RecordInEditModeCurrentlyRef.current =
              RecordInEditModeCurrently + 1;
            setRecordInEditModeCurrently(nextRecordIndex);
          }

          MNVMoverUnavailabilityGetCompleteGridDataForThisRule(
            unavailability.RuleFirstEntryID,
            nextRecordIndex,
          );
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  const MNVMoverUnavailabilityGetCompleteGridDataForThisRule = (
    EnteredID: number,
    MNVMoverUnavailabilityID: number,
  ) => {
    const data: any = {
      RuleFirstEntryID: EnteredID,
    };

    setIsAnimation(true);

    axiosAuth
      .post(
        `${AppContext.APIURL}api/MNVMoverUnavailability/MNVMoverUnavailabilityGetCompleteGridDataForThisRule`,
        data,
      )
      .then((result: any) => {
        setIsAnimation(false);

        // setOtherRecordsOfThisRule(result.data[0]);
        GetRecordForEdit(MNVMoverUnavailabilityID, result.data[0]);
      })
      .catch((error) => {
        setIsAnimation(true);
        console.error(error);
      });
  };

  const GetRecordForEdit = (
    MNVMoverUnavailabilityID: number,
    p_OtherRecordsOfThisRule: any,
  ) => {
    setIsAddNew(2);

    let thisData =
      p_OtherRecordsOfThisRule != null
        ? [...p_OtherRecordsOfThisRule]
        : [...OtherRecordsOfThisRule];

    const index = GetIndexExactlyMatchingColumn(
      thisData,
      "MNVMoverUnavailabilityID",
      MNVMoverUnavailabilityID,
    );

    if (index > -1) {
      if (RecordInEditModeCurrentlyRef.current == MNVMoverUnavailabilityID) {
        thisData[index].IsBold = true;
      }

      if (
        addEditObject?.MNVMoverUnavailabilityID !== MNVMoverUnavailabilityID
      ) {
        thisData[index].UseFullDay = false;
        setAddEditObject(thisData[index]);
      }
    }

    setOtherRecordsOfThisRule(thisData);
  };

  function CheckIfBothDatesAreSame(p_oID: any, p_gridview: boolean) {
    var l_intDaysDifference = getDifferenceInDays(
      new Date(addEditObject.StartDate),
      new Date(addEditObject.EndDate),
    );

    if (l_intDaysDifference != 0 || isAddNew == 2) {
      checkValidation(true, p_gridview);
    } else setSlotModalOpen(true);
  }

  const MNVMoverUnavailabilityGetRecordForEdit = (
    id: number,
    p_boolCheckOtherRecords: boolean = false,
  ) => {
    const record = thisGridListData.find(
      (x: any) => x.MNVMoverUnavailabilityID === id,
    );

    if (record) {
      setIsAddNew(2);
      record.UseFullDay = false;
      setAddEditObject(record);
    }

    // addEditObject.UseFullDay = false;

    setRecordInEditModeCurrently(record?.NextMNVMoverUnavailabilityID ?? null);

    setOtherRecordsOfThisRule([]);

    if (p_boolCheckOtherRecords && record?.RuleTypeID > 1) {
      MNVMoverUnavailabilityGetCompleteGridDataForThisRule(
        record.RuleFirstEntryID,
        record.NextMNVMoverUnavailabilityID,
      );
    }
  };

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <div className="flex-da gap-10">
              <div className="field-input date-field">
                <input
                  type="date"
                  title="Start Date"
                  value={filterObject.startdate}
                  onChange={(e) =>
                    setFilterbject((prevState: any) => ({
                      ...prevState,
                      startdate: e.target.value,
                    }))
                  }
                  className="input-field"
                />
              </div>
              <div className="field-input date-field">
                <input
                  type="date"
                  title="End Date"
                  value={filterObject.enddate}
                  onChange={(e) =>
                    setFilterbject((prevState: any) => ({
                      ...prevState,
                      enddate: e.target.value,
                    }))
                  }
                  className="input-field"
                />
              </div>
              <div className="flex-daj btn-start">
                <a
                  onClick={() => getScreenData()}
                  className="btn-primary flex-daj"
                >
                  Filter
                </a>
              </div>
            </div>

            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      MNVMoverUnavailabilityID: 0,
                      MNVMoverID: globalState.MNVMoverID,
                      RuleTypeID: 1,
                      RuleFirstEntryID: 0,
                      IsApproved: false,
                      Name: "Unapproved",
                      Reason: "",
                      StartDate: new Date(),
                      EndDate: new Date(),
                      UseFullDay: false,
                    });
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblvans", "Mover Unavailability")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>

          <table className="reuse-table" id="tblvans">
            <thead>
              <tr>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-daj flex-gap5">
                      Mover
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "MNVMoverName")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("MNVMoverName")}
                        title={"Sort By Mover Name"}
                      >
                        <span id={"imgSort" + "MNVMoverName"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-daj flex-gap5">
                      Reason
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "Reason")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("Reason")}
                        title={"Sort By Reason"}
                      >
                        <span id={"imgSort" + "Reason"}></span>
                      </a>
                    </div>
                  </div>
                </th>

                <th>Repeated</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {thisGridListData &&
                thisGridListData.map((item: any, index: any) => (
                  <React.Fragment key={index}>
                    {!item.IsExcluded && (
                      <tr>
                        <td>{item.MNVMoverName}</td>
                        <td>{item.Reason}</td>
                        <td>{item.RuleTypeID == 1 ? "No" : "Yes"}</td>
                        <td className={item.RuleTypeID > 1 ? "bold-font" : ""}>
                          {formateDateWithTime(item.NextStartDate)}
                        </td>
                        <td className={item.RuleTypeID > 1 ? "bold-font" : ""}>
                          {formateDateWithTime(item.NextEndDate)}
                        </td>
                        <td>{item.Name}</td>
                        <td>
                          <div className="flex-daj gap-10">
                            {(globalState.RolesList.RoleName == "Admin" ||
                              AppContext.IsSemiAdmin == 1) && (
                                <>
                                  {item.Name === "Approved" &&
                                    item.RuleTypeID > 1 && (
                                      <a
                                        title="Unapprove"
                                        onClick={() =>
                                          CheckApprovalType(
                                            item.MNVMoverUnavailabilityID,
                                            "ApprovalType",
                                            index,
                                          )
                                        }
                                      >
                                        <img
                                          src="images/r-cross.svg"
                                          width="18px"
                                          height="18px"
                                          alt="Edit"
                                        />
                                      </a>
                                    )}

                                  {item.Name === "Approved" &&
                                    item.RuleTypeID <= 1 && (
                                      <a
                                        title="Unapprove"
                                        onClick={() =>
                                          CheckApprovalType(
                                            item.MNVMoverUnavailabilityID,
                                            "",
                                            index,
                                          )
                                        }
                                      >
                                        <img
                                          src="images/r-cross.svg"
                                          width="18px"
                                          height="18px"
                                          alt="Edit"
                                        />
                                      </a>
                                    )}

                                  {/* APPROVE */}
                                  {item.Name === "Unapproved" &&
                                    item.RuleTypeID > 1 && (
                                      <a
                                        title="Approve"
                                        onClick={() =>
                                          CheckApprovalType(
                                            item.MNVMoverUnavailabilityID,
                                            "ApprovalType",
                                            index,
                                          )
                                        }
                                      >
                                        <img
                                          src="images/tick-g.svg"
                                          width="18px"
                                          height="18px"
                                          alt="Edit"
                                        />
                                      </a>
                                    )}

                                  {item.Name === "Unapproved" &&
                                    item.RuleTypeID <= 1 && (
                                      <a
                                        title="Approve"
                                        onClick={() =>
                                          CheckApprovalType(
                                            item.MNVMoverUnavailabilityID,
                                            "",
                                            index,
                                          )
                                        }
                                      >
                                        <img
                                          src="images/tick-g.svg"
                                          width="18px"
                                          height="18px"
                                          alt="Edit"
                                        />
                                      </a>
                                    )}
                                </>
                              )}

                            <button
                              className="no-borbg"
                              disabled={
                                !(
                                  globalState.RolesList.RoleName == "Admin" ||
                                  AppContext.IsSemiAdmin == 1 ||
                                  (globalState.RolesList.RoleName != "Admin" &&
                                    item.Name === "Unapproved")
                                )
                              }
                              onClick={() => {
                                setIsAddNew(2);
                                setAddEditObject({
                                  MNVMoverUnavailabilityID:
                                    item.MNVMoverUnavailabilityID,
                                  MNVMoverID: item.MNVMoverID,
                                  RuleTypeID: item.RuleTypeID,
                                  RuleFirstEntryID: item.RuleFirstEntryID,
                                  IsApproved: item.IsApproved,
                                  Name: item.Name,
                                  Reason: item.Reason,
                                  StartDate: item.StartDate,
                                  EndDate: item.EndDate,
                                  UseFullDay: false,
                                });
                                MNVMoverUnavailabilityGetRecordForEdit(
                                  item.MNVMoverUnavailabilityID,
                                  true,
                                );
                              }}
                            >
                              <img
                                src="images/edit.svg"
                                width="18px"
                                height="18px"
                                alt="Edit"
                              />
                            </button>
                            <a
                              onClick={() =>
                                globalState.setConfirmationModalObject({
                                  ShowPopup: true,
                                  Heading: "Alert",
                                  Message:
                                    "Are your sure, you want to delete this record?",
                                  ID: 1,
                                  SelectedID: item.NextMNVMoverUnavailabilityID,
                                  OtherID: item.RuleTypeID,
                                })
                              }
                            >
                              <img
                                src="images/delete.png"
                                width="18px"
                                height="18px"
                                alt="Delete"
                              />
                            </a>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="flex-da justify-btw gap-20">
              {(globalState.RolesList.RoleName == "Admin" ||
                AppContext.IsSemiAdmin == 1) && (
                  <div className="field-input grid-d  flex-gap3 w-30">
                    <span className="font-12 text-left label-color">Mover:</span>
                    <select
                      className="input-field w-100"
                      value={addEditObject.MNVMoverID}
                      onChange={(e) =>
                        setAddEditObject((prevState: any) => ({
                          ...prevState,
                          MNVMoverID: e.target.value,
                        }))
                      }
                    >
                      <option value={0}>Select Mover</option>
                      {screenListData[0] &&
                        screenListData[0].map((item: any, index: any) => (
                          <React.Fragment key={index}>
                            <option value={item.PID}>{item.Name}</option>
                          </React.Fragment>
                        ))}
                    </select>
                  </div>
                )}
              <div className="field-input grid-d flex-gap3 w-30">
                <span className="font-12 text-left label-color">Reason:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Reason}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Reason: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 flex-js text-left w-110">
                <span className="font-12 text-left label-color">
                  Use Full Day:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.UseFullDay}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      UseFullDay: e.target.checked,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 w-30">
                <span className="font-12 text-left label-color">
                  Start Date:
                </span>
                <input
                  type={
                    addEditObject.UseFullDay == false
                      ? "datetime-local"
                      : "date"
                  }
                  className="input-field w-100"
                  value={addEditObject.StartDate}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      StartDate: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 w-30">
                <span className="font-12 text-left label-color">End Date:</span>
                <input
                  className="input-field w-100"
                  type={
                    addEditObject.UseFullDay == false
                      ? "datetime-local"
                      : "date"
                  }
                  value={addEditObject.EndDate}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      EndDate: e.target.value,
                    }))
                  }
                />
              </div>
              {(globalState.RolesList.RoleName == "Admin" ||
                AppContext.IsSemiAdmin == 1) && (
                  <div className="field-input grid-d  flex-gap3 w-30">
                    <span className="font-12 text-left label-color">Status:</span>
                    <select
                      className="input-field w-100"
                      value={addEditObject.Name}
                      onChange={(e) =>
                        setAddEditObject((prevState: any) => ({
                          ...prevState,
                          Name: e.target.value,
                        }))
                      }
                    >
                      <option value={"Unapproved"}>Unapproved</option>
                      <option value={"Approved"}>Approved</option>
                    </select>
                  </div>
                )}
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  // onClick={() => checkValidation()}
                  onClick={() => CheckIfBothDatesAreSame(true, true)}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>

            {isAddNew == 2 && OtherRecordsOfThisRule.length > 0 && (
              <table className="reuse-table mt-20">
                <thead>
                  <tr>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {OtherRecordsOfThisRule.map((MNVMoverUnavailability: any) => (
                    <tr key={MNVMoverUnavailability.MNVMoverUnavailabilityID}>
                      <td
                        className={
                          MNVMoverUnavailability.IsBold ? "bold-font" : ""
                        }
                      >
                        {formateDateWithTime(MNVMoverUnavailability.StartDate)}
                      </td>

                      <td
                        className={
                          MNVMoverUnavailability.IsBold ? "bold-font" : ""
                        }
                      >
                        {formateDateWithTime(MNVMoverUnavailability.EndDate)}
                      </td>

                      <td>
                        <div className="flex-daj flex-gap10">
                          {(globalState.RolesList.RoleName == "Admin" ||
                            AppContext.IsSemiAdmin == 1) && (
                              <>
                                {MNVMoverUnavailability.Name === "Approved" && (
                                  <a
                                    title="Unapprove"
                                    onClick={() =>
                                      CheckApprovalType(
                                        MNVMoverUnavailability.MNVMoverUnavailabilityID,
                                        MNVMoverUnavailability.RuleTypeID > 1
                                          ? "ApprovalType"
                                          : "",
                                        0,
                                      )
                                    }
                                  >
                                    <img
                                      src="images/r-cross.svg"
                                      width="18px"
                                      height="18px"
                                      alt="Edit"
                                    />
                                  </a>
                                )}

                                {/* APPROVE */}
                                {MNVMoverUnavailability.Name === "Unapproved" && (
                                  <a
                                    title="Approve"
                                    onClick={() =>
                                      CheckApprovalType(
                                        MNVMoverUnavailability.MNVMoverUnavailabilityID,
                                        MNVMoverUnavailability.RuleTypeID > 1
                                          ? "ApprovalType"
                                          : "",
                                        0,
                                      )
                                    }
                                  >
                                    <img
                                      src="images/tick-g.svg"
                                      width="18px"
                                      height="18px"
                                      alt="Edit"
                                    />
                                  </a>
                                )}
                              </>
                            )}

                          <button
                            className="no-borbg"
                            title="Edit"
                            disabled={
                              !(
                                globalState.RolesList.RoleName == "Admin" ||
                                AppContext.IsSemiAdmin == 1 ||
                                (globalState.RolesList.RoleName != "Admin" &&
                                  MNVMoverUnavailability.Name === "Unapproved")
                              )
                            }
                            onClick={() =>
                              GetRecordForEdit(
                                MNVMoverUnavailability.MNVMoverUnavailabilityID,
                                null,
                              )
                            }
                          >
                            <img
                              src="images/edit.svg"
                              width="18px"
                              height="18px"
                              alt="Edit"
                            />
                          </button>
                          {!MNVMoverUnavailability.IsDeleted && (
                            <a
                              title="Delete"
                              onClick={() =>
                                MNVMoverUnavailabilityDeleteRecord(
                                  MNVMoverUnavailability.MNVMoverUnavailabilityID,
                                  MNVMoverUnavailability.RuleTypeID > 1
                                    ? MoverUnavailability
                                    : "",
                                )
                              }
                            >
                              <img
                                src="images/delete.png"
                                width="18px"
                                height="18px"
                                alt="Edit"
                              />
                            </a>
                          )}

                          {MNVMoverUnavailability.IsDeleted && (
                            <a
                              title="Undo delete"
                              onClick={() =>
                                MNVMoverUnavailabilityDeleteRecord(
                                  MNVMoverUnavailability.MNVMoverUnavailabilityID,
                                  "",
                                )
                              }
                            >
                              <img
                                src="images/refresh-t.svg"
                                width="18px"
                                height="18px"
                                alt="Edit"
                              />
                            </a>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        </div>
      )}

      {slotModalOpen && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0"> Slots Availability</h3>
                <a
                  className="close-help"
                  onClick={() => setSlotModalOpen(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="modal-body">
                <div className="grid-d fr-1 gap-20 mt-20">
                  {isAddNew == 1 && (
                    <div className="field-input grid-d  flex-gap3">
                      <span className="font-12 text-left label-color">
                        Mark as unavailable for
                      </span>

                      <select
                        className="input-field w-100"
                        value={addEditObject.RuleTypeID}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            RuleTypeID: e.target.value,
                          }))
                        }
                      >
                        {VanAvailabilityTypes.map((option: any) => (
                          <option key={option.ID} value={option.ID}>
                            {option.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {isAddNew == 2 && (
                    <div className="field-input grid-d  flex-gap3">
                      <span className="font-12 text-left label-color">
                        Mark as available for
                      </span>

                      <select
                        className="input-field w-100"
                        value={addEditObject.RuleTypeID}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            RuleTypeID: e.target.value,
                          }))
                        }
                      >
                        <option value={1}>Once</option>
                        <option value={2}>Delete Entire Rule</option>
                      </select>
                    </div>
                  )}
                </div>
                <div className="flex-daj btn-start gap-10 mt-20">
                  {isAddNew == 1 && (
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => {
                        checkValidation(false, true);
                      }}
                    >
                      Save
                    </a>
                  )}

                  {isAddNew == 2 && (
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => {
                        MNVMoverUnavailabilityDeleteRecord(0, "");
                      }}
                    >
                      Save
                    </a>
                  )}
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => {
                      setSlotModalOpen(false);
                    }}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {approvalTypeModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0"> Approval Type</h3>
                <a
                  className="close-help"
                  onClick={() => setapprovalTypeModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="modal-body">
                <div className="grid-d fr-1 gap-20 mt-20">
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Mark as approved for:
                    </span>

                    <select
                      className="input-field w-100"
                      value={addEditObject.RuleTypeID}
                      onChange={(e) =>
                        setAddEditObject((prevState: any) => ({
                          ...prevState,
                          RuleTypeID: e.target.value,
                        }))
                      }
                    >
                      <option value={1}>Once</option>
                      <option value={2}>Entire Rule</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="flex-daj btn-start gap-10 mt-20">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    MNVMoverUnavailabilityApproveAll();
                  }}
                >
                  Save
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setapprovalTypeModal(false);
                  }}
                >
                  Close
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MoverUnavailability;
